<script>
import Swal from "sweetalert2";
import CountriesApi from "@/services/countries-api";
import CampaignApi from "@/services/campaign-api";
import i18n from "../../../i18n";


export default {
      components: {},
  data() {
    return {
       
        pagemodelMain: {currentPage : 1, perPage : 15, totalRows: 0},

        citiesList:[],
        countriesList:[],
        selectedCountry:null,
        selectedCity:null,

        campaignList:[],
        customersFilter:null,
        isCampaignTableBusy:false,

        start:null,
        end:null,



        campaignListFields: 
            [
                { key:"timeStamp", label: "",thClass:"text-left ",tdClass:"text-left " ,thStyle:"min-width:130px;" },
                { key:"name", label: "",   sortable: false, tdClass:"font-weight-bold font-size-16 text-primary",thStyle:"min-width:130px;"},
                { key:"customerName", label: "",   sortable: false, tdClass:"font-weight-bold font-size-16 text-primary",thStyle:"min-width:130px;"},
                { key:"start", label: "",   sortable: false, tdClass:"font-weight-bold ", thStyle:"min-width:120px;"},
                { key:"end", label: "",   sortable: false, tdClass:"font-weight-bold ", thStyle:"min-width:120px;"},
                { key:"isCollectingData", label: "",thClass:"text-center ",tdClass:"text-center ",thStyle:"min-width:130px;"  },
                { key:"actions", label:"",thClass:"text-center ",tdClass:"text-center ", thStyle:"min-width:170px;"}
            ],

   
      }
      
    },

    
  mounted() {

    this.getCountries()

    this.findCampaign()
  },

  methods: {

    deleteCampaign(campaign){

      Swal.fire({
        title: i18n.t('parameters.swal.removeCampaign.title'),
        html: campaign.name,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d11010",
        cancelButtonColor: "#34c38f",
        cancelButtonText: i18n.t('parameters.swal.removeCampaign.cancelButtonText'),
        confirmButtonText: i18n.t('parameters.swal.removeCampaign.confirmButtonText'),
      }).then((result) => {
        if (result.value) {
          CampaignApi.deleteCampaign(this.pagemodelMain.currentPage, this.pagemodelMain.perPage, this.start , this.end , this.customersFilter, this.selectedCountry ? this.selectedCountry.id : null,this.selectedCity ? this.selectedCity.id : null , campaign.id)
          .then(response => {
                if(response) {
                    this.campaignList= response.list
                    this.pagemodelMain.totalRows = response.total;
                    this.pagemodelMain.currentPage = response.page;
                    this.pagemodelMain.perPage = response.pageSize;
                    this.pagemodelMain.pageSize = response.pageSize;
                  }   
                })
          .finally(() => {
            this.isCampaignTableBusy = false;
          });
        }
      });

    },
 
    getCountries(){
       CountriesApi.getCountries().then(
          result => {
            this.countriesList = result
        })
     },
    getCities(){
       CountriesApi.getCities(this.selectedCountry ? this.selectedCountry.id : this.campaign.country != null ? this.campaign.country.id : null).then(
          result => {
            this.citiesList = result
        })
     },
    
    findCampaign(){
        this.isCampaignTableBusy = true;
        CampaignApi.findCampaign(this.pagemodelMain.currentPage, this.pagemodelMain.perPage, this.start , this.end , this.customersFilter, this.selectedCountry ? this.selectedCountry.id : null,this.selectedCity ? this.selectedCity.id : null).then(
                response => {
                    if(response) {
                    this.campaignList= response.list
                    this.pagemodelMain.totalRows = response.total;
                    this.pagemodelMain.currentPage = response.page;
                    this.pagemodelMain.perPage = response.pageSize;
                    this.pagemodelMain.pageSize = response.pageSize;
                }   
                }
            )
            .finally(() => {
            this.isCampaignTableBusy = false;
      });
    },


},

    watch: {
        selectedCountry: function(){
          if(this.selectedCountry != null){
            this.getCities()
          }else{
              this.citiesList=[]
          }
            this.findCampaign()
        },

        "campaign.country": function(){
          if(this.campaign.country != null){
            this.getCities()
          }else{
              this.citiesList=[]
          }
            this.findCampaign()
        },

        selectedCity: function(){
            this.findCampaign()

        },

        start: function(){
            this.findCampaign()

        },

        end: function(){
            this.findCampaign()

        },
    }



};
</script>
<style>

    .style-vselect .vs__search {
      line-height: 1;
      color: #333333;
      font-size: 1em;
    }

   

    .style-vselect-big .vs__search::placeholder,
    .style-vselect-big .vs__dropdown-toggle,
    .style-vselect-big .vs__search,
    .style-vselect-big .vs__dropdown-menu {
      line-height: 1.6;
      font-size: 1em;
      background: white;
    }

    .style-vselect-big .vs__clear,
    .style-vselect-big .vs__open-indicator {
      fill: #000; /*#d90100;*/
    }

</style>
<template>

<div>
  
    <div class="row">
      <div class="col-md-8 col-12">
        <h2 class="card-title font-size-25 text-dark text-uppercase" style="font-size:25px;">{{$t('campaign.cardTitle')}} </h2>
      </div>

      <div class="col-md-4 col-12 text-right mt-md-0 mt-2">
        <router-link :to="{ path: '/campaign/details'}">
            <b-button variant="primary" class="mb-4 float-right">
                <span class=" text-uppercase font-weight-bold">
                {{$t('campaign.addNew')}}
                </span>
            </b-button>
        </router-link>  
      </div>
    </div>
    
    

    <div class="row pt-md-4 pt-2 mt-md-4 mt-2">    
      <div class="col-sm-12">
        <div class="">
          <div class="">
           

            <div class="row p-0 m-0 pb-4 mt-0 ">

                

                <div class ="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12 pr-lg-2 ">
                    <b-form-group :label="$t('lists.countries.filter')" label-for="">
                        <v-select class="style-vselect-big  font-size-16"  :options="countriesList" :placeholder="$t('lists.countries.label')"  label="name" v-model="selectedCountry">
                            <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                        </v-select>
                    </b-form-group>
                </div>

                <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12 pl-lg-2 pr-lg-0">
                    <b-form-group :label="$t('lists.cities.filter')"  label-for="">
                        <v-select class="style-vselect-big  font-size-16"  :options="citiesList" :placeholder="$t('lists.cities.label')" label="name" v-model="selectedCity">
                            <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                        </v-select>
                    </b-form-group>
                </div>

                <div class ="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 pl-lg-4 pr-lg-2 ">
                    <b-form-group :label="$t('subscription.nameFilter.label')" >
                        <b-input-group  >
                            <b-form-input :placeholder="$t('subscription.nameFilter.placeholder')"   v-model="customersFilter"   @keyup.native.enter="findCampaign() "
                            @keyup.enter="findCampaign()" ></b-form-input>                              
                            <template v-slot:append>
                                <b-button variant="primary" @click="findCampaign()" >
                                <i class="bx bx-search-alt font-weight-bold font-size-16 text-white align-middle"></i>
                                </b-button>
                            </template>
                        </b-input-group>
                    </b-form-group>
                </div>
                
             
            </div>

            <div class="row">
                    <div class="col-lg-3 col-md-4  pr-2">

                      <b-form-group >
                        <b-form-datepicker
                          v-model="start"
                          locale="fr"
                          label-no-date-selected="Date Début"
                          dark
                          reset-button
                          close-button
                          label-reset-button="Réinitialiser"
                          label-close-button="Fermer"
                          dropright
                          hide-header
                        ></b-form-datepicker>
                      </b-form-group>
                    </div>
                    <div class="col-lg-3 col-md-4 ">
                      <b-form-group  >
                        <b-form-datepicker
                          v-model="end"
                          locale="fr"
                          label-no-date-selected="Date Fin"
                          dark
                          reset-button
                          close-button
                          label-reset-button="Réinitialiser"
                          label-close-button="Fermer"
                          dropright                         
                          hide-header
                        ></b-form-datepicker>
                      </b-form-group>
                      
                    </div> 
              
              </div>

            <!-- <div class="row">
            
            </div> -->

            <div class="table-responsive mt-md-5 mt-3"> 
                <b-table 
                :busy="isCampaignTableBusy"
                :striped="true"
                :small="false"
                :hover="true"
                :items="campaignList"
                :fields="campaignListFields"
                :perPage="pagemodelMain.perPage"
                class="table  "
                >
                <template v-slot:table-busy>
                    <div class="text-center my-2">
                        <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                    </div>
                </template>

                <template v-slot:head(timeStamp)>
                {{ $t("campaign.table.head.timeStamp") }} 
                </template>
                <template v-slot:head(name)>
                  {{ $t("campaign.table.head.name") }} 
                </template>
                <template v-slot:head(customerName)>
                  {{ $t("campaign.table.head.customerName") }} 
                </template>
                <template v-slot:head(start)>
                  {{ $t("campaign.table.head.start") }} 
                </template>
                <template v-slot:head(end)>
                  {{ $t("campaign.table.head.end") }} 
                </template>
                <template v-slot:head(quantityColor)>
                  {{ $t("campaign.table.head.quantityColor") }} 
                </template>
                <template v-slot:head(bagSizeAsString)>
                  {{ $t("campaign.table.head.bagSizeAsString") }} 
                </template>
             
                <template v-slot:head(isCollectingData)>
                  {{ $t("campaign.table.head.isCollectingData") }} 
                </template>
        
                <template v-slot:cell(isCollectingData)="{value}">  
                  <i :class="value ? 'fas fa-check text-success' : 'fas fa-ban text-danger' " ></i>
                </template>
             
                <template v-slot:cell(actions)="{item}" >
                  <div class="text-right">

                    <router-link :to="{ path: '/campaign/details', query: { campaignId: item.id }}">
                        <b-button  title="Configurer le menu"  size="sm"  class="bg-light" variant="outline-info" >
                          <img class="align-middle" alt="Edit" width="20px" src="@/assets/icons/pencil.svg" style="cursor: pointer;"  />
                        </b-button> 
                    </router-link>

                    <span class="ml-2">
                      <b-button size="sm"  class="bg-light" variant="outline-info" @click="deleteCampaign(item)" >
                        <img class="align-middle" alt="trash" width="20px" src="@/assets/icons/trash.svg" style="cursor: pointer;" title="Supprimer le menu" />
                      </b-button> 
                    </span>

                </div>
                </template>
            
                </b-table>
                <span v-if="!isCampaignTableBusy & !campaignList.length" class="d-flex justify-content-center m-4 text-danger" >{{$t("subscription.table.empty")}}</span>
            </div>
            <!-- Pagination -->
            <div class="row pt-3 mb-sm-4">
                <div class="col-sm-8">
                    <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                        <b-form-select @input="findCampaign()"  v-model="pagemodelMain.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                        <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }}</span><span class="font-weight-bold"> {{pagemodelMain.totalRows}} {{ $t("pagination.lines") }}</span></div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="dataTables_paginate paging_simple_numbers float-right">
                        <ul class="pagination pagination-rounded mb-0">
                        <b-pagination v-model="pagemodelMain.currentPage" :disabled="isCampaignTableBusy" :per-page="pagemodelMain.pageSize" :total-rows="pagemodelMain.totalRows" @input="findCampaign()" ></b-pagination>
                        </ul>
                    </div>
                </div>
            </div> 
            <!-- Fin Pagination  -->
            

          </div>
        </div>
      </div>


    </div>

</div>
</template>
